import { render, staticRenderFns } from "./XmPreviewDownloadImg.vue?vue&type=template&id=65949fbd&scoped=true"
import script from "./XmPreviewDownloadImg.vue?vue&type=script&lang=js"
export * from "./XmPreviewDownloadImg.vue?vue&type=script&lang=js"
import style0 from "./XmPreviewDownloadImg.vue?vue&type=style&index=0&id=65949fbd&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "65949fbd",
  null
  
)

export default component.exports